import React from 'react';
import styles from '../style.module.css';
import { DataType, dataTypeLabels } from '../utils/enum';
import RadioButton from './RadioButton';

type Props = {
  handleRadioChangeActivityTotal: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  activityTotal: DataType;
  dataTypes: readonly DataType[];
};

const ActivityTotalOptions = ({
  activityTotal,
  handleRadioChangeActivityTotal,
  dataTypes,
}: Props) => {
  return (
    <div className={styles.radioButtons}>
      {dataTypes.map((value) => (
        <RadioButton
          name="activityTotal"
          value={value}
          checked={activityTotal === value}
          onChange={handleRadioChangeActivityTotal}
          label={dataTypeLabels[value]}
          key={`input-${value}`}
        />
      ))}
    </div>
  );
};

export default ActivityTotalOptions;
